// Copied verbatim from tab-portal src/lib/name-identification (qa c50f5268), the portal mirror of
// core-api src/utils/nameIdentification. Rules only: no AI pass. Keep the three in step.
/** Person vs business classification for legacy combined name columns. */
export type NameClassification = 'individual' | 'business'

/** Token order when parsing person names from a combined column. */
export type NameOrder = 'surname-first' | 'given-first'

export type TinHint = 'individual' | 'business' | 'unknown'

/** How the tinHint was derived — affects reviewer-facing signal text only. */
export type TinHintSource = 'tin-format' | 'id-type'

export interface ClassifyNameResult {
  classification: NameClassification
  /** 0–1 inclusive; multiply by 100 for display percentage. */
  confidence: number
  signal: string
  /** Name signal and TIN format disagree — always surface for human review. */
  conflict?: boolean
  /** Set when an AI second pass produced this result. */
  source?: 'deterministic' | 'ai' | 'user'
  /**
   * A formatted SSN/EIN decided this classification. The IRS format is a fact
   * about the row, not a guess — never send these to the AI pass, and never
   * let an AI or later merge step override them.
   */
  tinLocked?: boolean
}

export interface ParsedPersonName {
  first: string
  middle: string
  last: string
  suffix: string
}

export interface ParsedBusinessName {
  businessName1: string
  businessName2: string
}

/** Split DB columns derived from legacy combined name(s). */
export interface DerivedRecipientNameFields {
  RECIPIENT_FIRST_NAME: string
  RECIPIENT_MIDDLE_NAME: string
  RECIPIENT_LAST_NAME: string
  RECIPIENT_SUFFIX: string
  RECIPIENT_BUSINESS_NAME1: string
  RECIPIENT_BUSINESS_NAME2: string
}

export interface ClassifyNameOptions {
  /** Local TIN-format hint — derived locally, never sent to AI. */
  tinHint?: TinHint
  /** When tinHint came from RECIPIENT_ID_TYPE rather than dashed TIN formatting. */
  tinHintSource?: TinHintSource
  /** Reviewer or portal decision — skips re-classification. */
  classificationOverride?: NameClassification
}

/** One name submitted to the AI second pass. Name string only — no TIN. */
export interface AiClassifyRequestItem {
  name: string
}

/** IRS combined business name line length limit. */
export const BUSINESS_NAME_MAX_LEN = 40
